<template>
  <div class="map">
    <div class="map-content">
      <div id="container" style="width:100%; height:100vh"></div>
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
import { mapList } from "@/api/agency";
import { areaCode } from "@/common/constants.js";
import staticOrgData from "@/common/staticOrgData.json";

import redMark from "../../assets/images/redMark.png";

export default {
  name: "index",
  data() {
    return {
      centerCo: [121.47254, 31.232777],
      map: "",
      mapList: [] // 所有的机构数据
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.getMapList();
      await this.init();
    },
    init() {
      return new Promise(() => {
        var map = new AMap.Map("container", {
          resizeEnable: true,
          center: this.centerCo,
          zoom: 16
        });

        let filterList = []
        // 养老院特殊处理,取写死的一家
        if(this.$route.query.type == '养老院'){
          filterList = this.mapList.filter(
            item => item.id == 'yly1'
          );
        }else{
          // 过滤需要显示的机构类型
          filterList = this.mapList.filter(
            item => item.type == this.$route.query.type
          );
        }
        // console.log(filterList)


        filterList.forEach(item => {
          if (item.arr[0] !== "" && item.arr[1] !== "") {
            let content =
              '<div class="marker-box">' +
              '<div class="marker-name">' +
              '<img src="' +
              require(`@/assets/images/${item.type}.png`) +
              '">' +
              "<span>" +
              item.name +
              "</span>" +
              '<div class="triangle2"></div>' +
              "</div>" +
              '<img src="' +
              redMark +
              '">' +
              "</div>";

            const marker = new AMap.Marker({
              map: map,
              content: content,
              position: new AMap.LngLat(item.arr[0], item.arr[1]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: item.name,
              anchor: "bottom-center",
            });
            let _this = this;
            AMap.event.addListener(marker, "click", function() {
              _this.togglePage("agencyDetail", item.id);
            });
          }
        });
        map.setFitView();
        this.map = map;
      });
    },
    getMapList() {
      return new Promise(resolve => {
        mapList(areaCode).then(res => {
          if (res.code === 0) {

            // 后台返回的数据,加上前端写死的部分机构数据
            let allList = [
              ...res.data.list,
              ...this.transformData(staticOrgData.list)
            ];

            allList.forEach(item => {
              const data = {};
              if (item.longitude !== null && item.latitude !== null) {
                data.arr = [item.longitude, item.latitude];
                data.name = item.org_name;
                data.id = item.org_id;
                data.orgType = item.org_type;
                switch (item.org_type) {
                  case "1010":
                    data.type = "养老院";
                    break;
                  case "1011":
                    data.type = "长者照护之家";
                    break;
                  case "2011":
                    data.type = "综合为老服务中心";
                    break;
                  case "2025":
                    data.type = "睦邻中心";
                    break;
                  case "2026":
                    data.type = "适老化智慧养老体验中心";
                    break;
                  case "2010":
                    data.type = "老年日托所";
                    break;
                  case "2014":
                    data.type = "助餐点";
                    break;
                  case "2024":
                    data.type = "社区为老服务站";
                    break;
                  case "2027":
                    data.type = "长者运动健康之家";
                    break;
                  case "2013":
                    data.type = "老年活动室";
                    break;
                }
                this.mapList.push(data);
              }
            });
          }
          resolve();
        });
      });
    },
    // 转换静态的机构列表数据的字段函数
    transformData(list) {
      let resList = [];
      list.forEach(obj => {
        let o = {};
        o.org_id = obj.orgId;
        o.org_name = obj.orgName;
        o.area_code = "";
        o.phone = obj.phone;
        o.addr = obj.addr;
        o.org_type = obj.orgType;
        o.longitude = obj.longitude;
        o.latitude = obj.latitude;
        resList.push(o);
      });
      return resList;
    },

    // 跳转机构详情
    togglePage(name, orgId) {
      this.$router.push({ name, query: { orgId } });
    }
  }
};
</script>

<style lang="scss">
.marker-box {
  width: 150px;
  .marker-name {
    background-color: #5ed9c3;
    width: 150px;
    border-radius: 10px;
    padding: 8px;
    display: flex;
    align-items: center;
    position: relative;
    > img {
      width: 20px;
      height: 20px;
    }
    span {
      padding-left: 5px;
      font-size: 10px;
      color: white;
      display: inline-block;
      line-height: 15px;
    }
    .triangle2 {
      display: inline-block;
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-top-color: #5ed9c3;
      position: absolute;
      bottom: -10px;
      left: 65px;
    }
  }
  > img {
    width: 15px;
    margin-left: 63px;
    margin-top: 5px;
  }
}

.map {
  width: 100%;
  height: 100%;
  background: #f5f5f5;

  .map-content {
    width: 100%;
    height: calc(100% - 54px);
  }
}
</style>
